<template>
  <div>
    <Spinner v-if="isLoading" />
    <div v-else>
      <h3>{{ $t("organisation.default_asp.select.label") }}</h3>
      <vca-dropdown
        ref="default_asp"
        v-model="default_asp"
        :options="defaultAspList"
        :rules="$v.value.default_asp"
        label=""
        :errorMsg="$t('organisation.default_asp.select.errorMsg')"
        :placeholder="$t('organisation.default_asp.select.placeholder')"
      />
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner.vue";
import { mapGetters } from "vuex";
export default {
  name: "EventsFormAsp",
  components: { Spinner },
  data() {
    return {
      isLoading: false,
      defaultAspList: [],
    };
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return this.validation;
  },
  mounted() {
    this.updateDefaultAspList();
  },
  methods: {
    validate() {
      this.$refs.default_asp.validate();
    },
    updateDefaultAspList() {
      let data = {
        system_roles: ["employee", "pool_employee"],
        organisation_id: "",
      };
      this.isLoading = true;
      this.$store
        .dispatch({ type: "users/queryList", data: data })
        .then((response) => {
          this.defaultAspList = response.filter((el) => {
            el.title = el.full_name;
            el.label = el.full_name;
            el.subtitle = el.display_name + " <" + el.email + ">";
            el.value = el.id;
            if (this.value.default_asp_id == "" && el.id == this.user.id) {
              this.default_asp = [el];
            }
            return true;
          });
          this.isLoading = false;
        });
    },
  },
  computed: {
    full_name() {
      return this.value.default_asp.full_name;
    },
    email() {
      return this.value.default_asp.email;
    },
    phone: {
      get() {
        return this.value.default_asp.profile.phone;
      },
      set(value) {
        this.value.phone = value;
      },
    },
    default_asp: {
      get() {
        return [{ value: this.value.default_asp_id }];
      },
      set(value) {
        let newValue = this.value;
        newValue.default_asp_id = value.length ? value[0].id : "";
        newValue.default_asp = value.length ? value[0] : "";
        this.value = newValue;
      },
    },
    userSelection() {
      return this.usersList.filter((el) => {
        el.title = el.full_name;
        el.label = el.full_name;
        el.subtitle = el.display_name + " <" + el.email + ">";
        el.value = el.id;
        return true;
      });
    },
    ...mapGetters({
      user: "user/current",
      usersList: "users/list",
      validation: "events/validations",
      hasSystemPermission: "user/roles/hasSystemPermission",
    }),
  },
};
</script>
